import { Progress } from "antd";
import React from "react";

export const ProgressIndicator = ({ colorFormat = {}, percent = 0, status = "active", type = "line", propsProgress = {} }) => {
	return (
		<Progress
			{...propsProgress}
			percent={percent}
			type={type}
			format={() => {
				return <span style={{ ...colorFormat }}>{parseInt(percent)}%</span>;
			}}
			status={status}
		/>
	);
};
